import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table, {ColumnType, SetPage, SetRowsPerPage, Sort} from '@pluto/table';

import './List.scss';
import {AppName} from '../Redux/Types';
import Toolbar from './Toolbar';

export interface AppNamesListProps {
    data: AppName[];
    columns: ColumnType[];
    total: number;
    page: number;
    setSort: () => void;
    sort: Sort;
    onPaging: () => void;
    setPage: SetPage;
    rowsPerPage: number;
    setRowsPerPage: SetRowsPerPage;
}

export default function AppNamesList(props: AppNamesListProps) {
    const {
        data,
        total,
        columns,
        page,
        setSort,
        sort,
        onPaging,
        setPage,
        rowsPerPage,
        setRowsPerPage,
    } = props;
    return (
        <Box>
            <Typography
                variant="h5"
                className="list__heading"
            >
                APP PROFILE MANAGEMENT
            </Typography>
            <Toolbar />
            <Table
                data={data}
                columns={columns}
                total={total}
                onChangePageHandler={onPaging}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                setSort={setSort}
                sort={sort}
            />
        </Box>
    );
}
